/**
 * The timestamp at the top of the move-details info section, with its tooltip label.
 *
 * Which timestamp it reads comes from `resolveMoveMilestoneTime`, which falls back through
 * the move's own timestamps: delivery_successful, delivery_arrived, pickup_successful,
 * pickup_arrived, then the scheduled `ready_by`. Only the label is decided here; `ready_by`
 * keeps its existing label, the appointment on a customer (consumer) move.
 */

import { resolveMoveMilestoneTime, type MoveMilestoneTimeInput } from '@hopdrive/feature-order-index';

export type MoveHeaderTimeInput = Partial<MoveMilestoneTimeInput> & { consumer_type?: string | null };

export interface MoveHeaderTime {
  time: string | null;
  label: string;
}

export const getMoveHeaderTime = (move?: MoveHeaderTimeInput | null): MoveHeaderTime => {
  const milestone = resolveMoveMilestoneTime({
    delivery_successful: move?.delivery_successful ?? null,
    delivery_arrived: move?.delivery_arrived ?? null,
    pickup_successful: move?.pickup_successful ?? null,
    pickup_arrived: move?.pickup_arrived ?? null,
    ready_by: move?.ready_by ?? null,
  });
  if (milestone.kind === 'delivered') return { time: milestone.at, label: 'Delivered Time' };
  if (milestone.kind === 'pickup') return { time: milestone.at, label: 'Pickup Time' };
  return { time: milestone.at, label: move?.consumer_type === 'customer' ? 'Appointment' : 'Ready By' };
};
